/** `Smart Content, Smart Pricing, and Smart Shipping` — Oxford comma included. */
export const formatModuleList = (names: readonly string[]): string =>
  new Intl.ListFormat("en", { style: "long", type: "conjunction" }).format(
    names
  );

export const formatBillingPrice = (value: number): string =>
  value.toLocaleString("en-US", {
    maximumFractionDigits: 2,
    minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
  });
